import {ProxyService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _ProxyService = new ProxyService({client});
export {_ProxyService as ProxyService};
